import { useMutation, useQueryClient } from 'react-query';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { ICreateStitchedImageResponse } from '../../../Entities';
import { Translate } from '../../../../../../../shared/LanguageService';
import { imagesQueryKey } from '../../listImages/queries/use-query-images';
import { photoStatusQueryKey } from '../../entry/queries/use-query-photo-status';

export type PinRequest = {
    x: number;
    y: number;
    size: number;
    color: string;
};

type CreatePinnedImageMutationArgs = {
    orderId: number;
    imageId: number;
    onCreated: (response: ICreateStitchedImageResponse) => void;
    onFailed: (messages: string[]) => void;
};

async function readErrorMessages(error: { response?: Response } | null): Promise<string[]> {
    const fallback = [Translate('500-error/description')];

    if (!error || !error.response) {
        return fallback;
    }

    try {
        const body: { errors: { value: string }[] } = await error.response.json();
        return body.errors.map((item) => Translate(item.value));
    } catch (e) {
        return fallback;
    }
}

export function useCreatePinnedImageMutation({
    orderId,
    imageId,
    onCreated,
    onFailed
}: CreatePinnedImageMutationArgs) {
    const queryClient = useQueryClient();

    return useMutation(
        (pin: PinRequest) =>
            ImageProcessingApi.createPinnedImage(
                orderId,
                imageId,
                pin.x,
                pin.y,
                pin.size,
                pin.color
            ),
        {
            onSuccess: (response: ICreateStitchedImageResponse) => {
                onCreated(response);

                setTimeout(() => {
                    queryClient.invalidateQueries(imagesQueryKey);
                    queryClient.invalidateQueries(photoStatusQueryKey);
                }, 90);
            },
            onError: async (error: { response?: Response } | null) => {
                onFailed(await readErrorMessages(error));
            }
        }
    );
}
